<script lang="ts">
    import { blur } from 'svelte/transition';
    import { _ } from 'svelte-i18n';
    import { closeModal } from 'svelte-modals';

    import WidgetTemplateOneComponent from './WidgetTemplateOneComponent.svelte';
    import type { WidgetTemplateList } from './WidgetTemplateList';
    import FilterTemplates from './FilterTemplates.svelte';
    import type { WidgetTemplateResponseType } from '../WidgetTemplateApi';
    import { SwitchBarApp } from '../../SwitchBar/SwitchBarApp';
    import { app } from '../../../../stores/app';
    import { filterDashboardTemplatesQuery, filterDashboardTemplatesSelectedPermission } from './store';
    import SwitchBar from '../../SwitchBar/SwitchBar.svelte';

    let filteredTemplates: WidgetTemplateResponseType[] = [];
    let switchBarApp: SwitchBarApp = new SwitchBarApp()
        .setItems([
            { id: 'all', label: $_('Wszystkie') },
            { id: 'private', label: $_('Prywatne') },
            { id: 'public', label: $_('Grupy') },
        ])
        .selectItem($filterDashboardTemplatesSelectedPermission);

    export let componentProps: {
        title: string;
        widgetTemplateList: WidgetTemplateList;
        onSelect: (templateId: number) => void;
        onChange?: (templates: WidgetTemplateResponseType[]) => void;
    };

    function onSelect(templateId: number) {
        console.log('WidgetTemplateListComponent', templateId);
        componentProps.widgetTemplateList.setCurrentTemplateId(templateId);
        closeModal();
        componentProps.onSelect(templateId);
    }

    function onChange(templates: WidgetTemplateResponseType[]) {
        if (typeof componentProps?.onChange === 'function') {
            componentProps.onChange(templates);
        } else {
            console.warn('WidgetTemplateListComponent, onChange is not a function');
        }
    }

    $: {
        console.log('WidgetTemplateListComponent, filter', $filterDashboardTemplatesQuery);
        filteredTemplates = componentProps.widgetTemplateList.getTemplates().filter(template => {
            return template.label
                .toLowerCase()
                .includes($filterDashboardTemplatesQuery.toLowerCase());
        });

        switch ($filterDashboardTemplatesSelectedPermission) {
            case 'all':
                // get all templates
                filteredTemplates = filteredTemplates;
                break;
            case 'private':
                // get only mine templates and private
                filteredTemplates = filteredTemplates.filter(template => {
                    return (
                        template.user_private === true &&
                        template.webuser_id === $app.account.getWebuserId()
                    );
                });
                break;
            case 'public':
                // get not mine templates or my but not private
                filteredTemplates = filteredTemplates.filter(template => {
                    return (
                        template.user_private === false ||
                        template.webuser_id !== $app.account.getWebuserId()
                    );
                });
                break;
        }
    }
</script>

<div class="template-list-container">
    <div class="template-list-header">
        <div style="font-size: 16px;">
            <div style="text-transform: capitalize">{$_(componentProps.title)}</div>
        </div>
    </div>
    <div class="template-list-body">
        <div
            style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; margin: 10px 0; font-size: 12px;"
        >
            <FilterTemplates />
            <SwitchBar
                bind:switchBarApp
                onChange={ids => {
                    console.log('Selected', ids);
                    $filterDashboardTemplatesSelectedPermission = ids[0];
                }}
            />
        </div>
        <div class="job-list" style="max-height: 265px; overflow: auto;">
            {#each filteredTemplates as template, index (template.id)}
                <div in:blur|global>
                    <WidgetTemplateOneComponent
                        showHeader={filteredTemplates[0].id === template.id}
                        {template}
                        {onSelect}
                        {onChange}
                        currentId={componentProps.widgetTemplateList.getCurrentTemplateId()}
                        bind:widgetTemplateList={componentProps.widgetTemplateList}
                    />
                </div>
            {:else}
                <div class="not-found-anything">{$_('No items found')}</div>
            {/each}
        </div>
    </div>
</div>

<style>
    .template-list-container {
        display: flex;
        flex-direction: column;
        min-width: 590px;
        min-height: 410px;
        background-color: #dbdbd6;
        border-radius: 6px;
    }
    .template-list-header {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        background-color: #f5f5f0;
        padding: 10px 20px 10px 20px;
        border-radius: 6px 6px 0 0;
    }
    .template-list-body {
        display: flex;
        flex-direction: column;
        row-gap: 10px;
        background-color: #dbdbd6;
        padding: 10px 20px 20px 20px;
        border-radius: 0 0 6px 6px;
    }
    .not-found-anything {
        display: flex;
        justify-content: center;
        min-height: 170px;
        align-items: center;
        opacity: 0.5;
    }
</style>
